<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit"
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.titulo" [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevo()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i>  {{DAT_BTNS.agregarTicketAutorizacionTransporte}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <div class="col-md-4">
      <label for="cmbEstados">Filtrar por Estado</label>
      <select [(ngModel)]="estadoSeleccionado" (ngModelChange)="onChangeFiltros($event)" class="form-control btn-outline-success" name="cmbEstados" id="cmbEstados">
        <option value="1">Ingresos (vehículo ingresó)</option>
        <option value="0">Salidas (vehículo salió)</option> 
        <option value="2">Activos-Validos(Ingresos y Salidas)</option>
        <option value="7">Anulados</option>
        <option value="3">Todos</option>
      </select>
    </div>
    <br/>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
      [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
      [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion" [pagination]="true"
      [rowData]="rowData">
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [classModal]="'modal-lg'" [idButton]="'abrirModalAregarTicket'" [idClose]="'cerrarModalAgregarTicket'"
  [innTemplate]="abrirModalAgregarTicketTransporte" [titulo]="tituloModal"></app-lfsa-modal>

<ng-template #abrirModalAgregarTicketTransporte>
  <div class="container-fluid">
    <form [formGroup]="ticketAutorizacionTransporteForm" class="row">
      <div class="col-lg-3 mb-2">
        <label for="nroAutorizacionTransporte">Nro Autorizacion Transporte</label>
        <input class="form-control" formControlName="nroAutorizacionTransporte" name="nroAutorizacionTransporte"
          type="text">
        <small *ngIf="ticketAutorizacionTransporteForm.get('nroAutorizacionTransporte')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
      </div>

      <div class="col-lg-3 mb-2">
        <label for="usuario">Usuario</label>
        <input class="form-control" formControlName="usuario" name="usuario" type="text" readonly>
      </div>

      <div class="col-lg-3 mb-2">
        <label for="fecha">Fecha/Hora</label>
        <input autocomplete="off" class="form-control" formControlName="fecha" name="fecha" type="text">
        <small *ngIf="ticketAutorizacionTransporteForm.get('fecha')?.hasError('required')" class="text-danger">*Este campo es requerido</small>
      </div>

      <div class="col-lg-3 mb-2">
        <label for="idTipoOrd">Tipo Servicio</label>
        <select (ngModelChange)="onChangeTipoServicio($event)" class="form-control" formControlName="idTipoOrd" name="idTipoOrd">
          <option value="">-- Seleccione --</option>
          <option value="1">Contratado</option>
          <option value="2">Vehículo Propio</option>
          <option value="3">Ocasional</option>
          <option value="4">Importaciones</option>
          <option value="5" disabled>Planificaciones</option>
        </select>
        <small *ngIf="ticketAutorizacionTransporteForm.get('idTipoOrd')?.hasError('required')" class="text-danger">
          *Este campo es requerido
        </small>
      </div>

      <div class="col-lg-12 mb-2" *ngIf="this.ticketAutorizacionTransporteForm.get('idTipoOrd').value == 4">
        <label for="tanqueros">Seleccione Información de tanquero (está acción rellenará los campos desde el tanquero)</label>
          <select class="form-control" formControlName="tanqueros" name="tanqueros">
            <option value="">-- Seleccione --</option>
            <option *ngFor="let tanquero of tanquerosList" [value]="tanquero.idTanquero">Tanquero - {{tanquero.numeroTanquero}} - {{tanquero.placa}}</option>
          </select>
      <!-- (ngModelChange)="onChangeTanquero($event);" -->
      </div>
      
      <!-- T.13581 GARITA EN TODAS LAS AGENCIAS -->
      <div class="col-lg-6 mb-2">
        <label for="garitaAsignadaDescripcion">Garita Asignada</label>
        <input autocomplete="off" class="form-control" formControlName="garitaAsignadaDescripcion"
          name="garitaAsignadaDescripcion" readonly type="text">
        <small *ngIf="ticketAutorizacionTransporteForm.get('garitaAsignada')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
      </div>
      <!-- END -->

      <div class="col-lg-6 mb-2">
        <div class="row">
          <div class="col-lg-10">
            <app-lfsa-input [isReadOnly]="false" [type]="'number'" [class]="''" [label]="'Buscar Ticket Garita Origen'" 
            [id]="'authOrigenId'" formControlName="authOrigenId" [control]="ticketAutorizacionTransporteForm.get('authOrigenId')">
            </app-lfsa-input>
          </div>          
          <div class="col-lg-1 ps-0">
            <button (click)="getTicketOrigen()" class="btn btn-success mt-4">Buscar
            </button>
          </div>          
        </div>
      </div>

      <div class="col-lg-12 mb-2">
        <div class="row">
          <div class="col-lg-3">
            <label for="placa">Placa</label>
            <input class="form-control" formControlName="placa" id="placa" name="placa" type="text">
            <div
              *ngIf="ticketAutorizacionTransporteForm.controls['placa'].invalid && (ticketAutorizacionTransporteForm.controls['placa'].dirty || ticketAutorizacionTransporteForm.controls['placa'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="ticketAutorizacionTransporteForm.controls['placa'].errors"> El campo es requerido. </div>
              </small>
            </div>
          </div>
          <div class="col-lg-1 ps-0">
            <button (click)="buscarPlacaTransporte()"
              [disabled]="ticketAutorizacionTransporteForm.controls['placa'].errors" class="btn btn-success mt-4">Buscar
            </button>
          </div>
          <div class="col-lg-8">
            <div class="row">
              <div class="form-group col-4">
                <label for="placaTransportista">Vehículo</label>
                <input class="form-control" formControlName="vehiculo" id="vehiculo" name="vehiculo" readonly
                  type="text">
              </div>
              <div class="form-group col-4">
                <label for="placaTransportista">Marca</label>
                <input class="form-control" formControlName="marca" id="marca" name="marca" readonly type="text">
              </div>
              <div class="form-group col-4">
                <label for="placaTransportista">Modelo</label>
                <input class="form-control" formControlName="modelo" id="modelo" name="modelo" readonly type="text">
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12 mb-2">
        <div class="row">
          <div class="col-lg-3">
            <label for="proveedorTransp">RUC Proveedor Transporte</label>
            <input class="form-control" formControlName="proveedorTransp" id="proveedorTransp" name="proveedorTransp" type="text">
            <div *ngIf="ticketAutorizacionTransporteForm.controls['proveedorTransp'].invalid && (ticketAutorizacionTransporteForm.controls['proveedorTransp'].dirty || ticketAutorizacionTransporteForm.controls['proveedorTransp'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="ticketAutorizacionTransporteForm.controls['proveedorTransp'].errors">
                  El campo es requerido.
                </div>
              </small>
            </div>
          </div>
          
          <div class="col-lg-1 ps-0">
            <!-- KD: RTI-TICKET 14038 CONTROL DE CAMBIO DE BALANZA. NO BUSCA PROV.TRANSPORTE TOMA DIRECTAMENTE DEL VALOR RELACIONADO DE LA PLACA -->
            <!-- KD: TICKET 23960 DESCOMENTA TICKET 14038, ACTIVO Y OPTATIVO PARA TIPOS OCACIONALES. IMPORTACIONES MANTIENE FUNCIONALIDAD-->
            <button *ngIf="this.tipoOrden.value == 3 && this.tipoOrden.value != null" 
                    (click)="onChangeProveedorTransporte($event)" 
                    [disabled]="ticketAutorizacionTransporteForm.controls['proveedorTransp'].errors"
                    class="btn btn-success mt-4">Buscar 
              </button>
          </div>
          
          <div class="col-lg-8">
            <label for="detProveedorTransporte">Detalle Proveedor Transporte</label>
            <input class="form-control" formControlName="detProveedorTransporte" id="detProveedorTransporte" readonly
              type="text">
          </div>
        </div>
      </div>

      <div class="col-lg-12 mb-2">
        <div class="row">
          <div class="col-lg-3">
            <label for="cliente">Código Cliente</label>
            <input class="form-control" formControlName="cliente" id="cliente" name="cliente" type="text">
            <div
              *ngIf="ticketAutorizacionTransporteForm.controls['cliente'].invalid && (ticketAutorizacionTransporteForm.controls['cliente'].dirty || ticketAutorizacionTransporteForm.controls['cliente'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="ticketAutorizacionTransporteForm.controls['cliente'].errors">
                  El campo es requerido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-1 ps-0">
            <button (click)="buscarCliente()" [disabled]="ticketAutorizacionTransporteForm.controls['cliente'].errors"
              class="btn btn-success mt-4">Buscar
            </button>
          </div>
          <div class="col-lg-8">
            <label for="clienteDetalle">Detalle CLiente</label>
            <input class="form-control" formControlName="clienteDetalle" id="clienteDetalle" readonly type="text">
          </div>
        </div>
      </div>

      <div class="col-lg-12 mb-2">
        <div class="row">
          <div class="col-lg-3">
            <label for="proveedor">RUC del proveedor de compra</label>
            <input class="form-control" formControlName="proveedor" id="proveedor" name="proveedor" type="text">
            <div
              *ngIf="ticketAutorizacionTransporteForm.controls['proveedor'].invalid && (ticketAutorizacionTransporteForm.controls['proveedor'].dirty || ticketAutorizacionTransporteForm.controls['proveedor'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="ticketAutorizacionTransporteForm.controls['proveedor'].errors">
                  El campo es requerido.
                </div>
                <div *ngIf="ticketAutorizacionTransporteForm.get('proveedor')?.hasError('maxlength')"
                  class="text-danger">*Máximo 20 caracteres
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-1 ps-0"> <!--style="display: flex;flex-direction: column;justify-content: end;"-->
            <button (click)="buscarProveedor()"
              [disabled]="ticketAutorizacionTransporteForm.controls['proveedor'].errors"
              class="btn btn-success mt-4">Buscar
            </button>
          </div>
          <div class="col-lg-8" style="display: flex;flex-direction: column;justify-content: end;">
            <label for="detProveedor">Detalle Identificación del proveedor de compra</label>
            <input class="form-control" formControlName="detalleProveedor" id="detProveedor" readonly type="text">
          </div>
        </div>
      </div>

      <div class="col-lg-12 mb-2">
        <div class="row">
          <div class="col-lg-3">
            <label for="chofer">Cedula chofer</label>
            <input class="form-control" formControlName="cedula" id="cedula" name="cedula" type="text">
            <div
              *ngIf="ticketAutorizacionTransporteForm.controls['cedula'].invalid && (ticketAutorizacionTransporteForm.controls['cedula'].dirty || ticketAutorizacionTransporteForm.controls['cedula'].touched)"
              class="text-danger">
              <small>
                <div *ngIf="ticketAutorizacionTransporteForm.controls['cedula'].errors">
                  Formato inválido.
                </div>
              </small>
            </div>
          </div>
          <div class="col-lg-1 ps-0">
            <button (click)="buscarCedulaChofer()"
              [disabled]="ticketAutorizacionTransporteForm.controls['cedula'].errors"
              class="btn btn-success mt-4">Buscar
            </button>
          </div>
          <div class="col-lg-5">
            <label for="detTransporte">Apellidos y Nombres</label>
            <input class="form-control" formControlName="chofer" id="chofer" readonly type="text">
          </div>
          <div class="col-lg-3">
            <label for="detTransporte">Celular</label>
            <input class="form-control" formControlName="celular" id="celular" readonly type="text">
          </div>
        </div>
      </div>

      <div class="col-lg-3 mb-2">
        <label for="referenciaProducto">Referencia Productos</label>
        <input class="form-control" formControlName="referenciaProducto" name="referenciaProducto" />
        <small *ngIf="ticketAutorizacionTransporteForm.get('referenciaProducto')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
        <small *ngIf="ticketAutorizacionTransporteForm.get('referenciaProducto')?.hasError('maxlength')"
          class="text-danger">*Máximo 50 caracteres</small>
      </div>

      <div class="col-lg-3 mb-2">
        <label for="sellos">Sellos</label>
        <input class="form-control" formControlName="sellos" name="sellos" />
        <small *ngIf="ticketAutorizacionTransporteForm.controls['proveedor'].errors" class="text-danger">
          *Este campo es requerido</small>
        <small *ngIf="ticketAutorizacionTransporteForm.get('sellos')?.hasError('maxlength')" class="text-danger">
          *Máximo 105 caracteres</small>
        <small *ngIf="ticketAutorizacionTransporteForm.get('sellos')?.hasError('pattern')" class="text-danger">
          *Solo caracteres alfanumericos y - </small>
      </div>

      <div class="col-lg-3 mb-2">
        <app-lfsa-input [isReadOnly]="false" [type]="'datetime-local'" [class]="''" [label]="'Seleccione fecha y hora real de llegada'" 
        [id]="'fechaLlegada'" formControlName="fechaLlegada" [control]="ticketAutorizacionTransporteForm.get('fechaLlegada')">
        </app-lfsa-input>
      </div>

      <div class="col-lg-3 mb-2">
        <label for="ordenFlete">Orden de Flete</label>
        <input class="form-control" formControlName="ordenFlete" id="ordenFlete" type="text" maxlength="22">
      </div>

      <div class="col-lg-3 mb-2">
        <label for="facturaGuia">Factura / Guía</label>
        <input class="form-control" formControlName="facturaGuia" name="facturaGuia" />
        <small *ngIf="ticketAutorizacionTransporteForm.get('facturaGuia')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
        <small *ngIf="ticketAutorizacionTransporteForm.get('facturaGuia')?.hasError('maxlength')"
          class="text-danger">*Máximo 50 caracteres</small>
      </div>

      <div class="col-lg-3 mb-2">
        <label for="lugarSalida">Lugar Salida</label>
        <input class="form-control" formControlName="lugarSalida" name="lugarSalida" />
        <small *ngIf="ticketAutorizacionTransporteForm.get('lugarSalida')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
        <small *ngIf="ticketAutorizacionTransporteForm.get('lugarSalida')?.hasError('maxlength')"
          class="text-danger">*Máximo 50 caracteres</small>
      </div>

      <div class="col-lg-3 mb-2">
        <label for="lugarLlegada">Lugar Llegada</label>
        <input class="form-control" formControlName="lugarLlegada" name="lugarLlegada" />
        <small *ngIf="ticketAutorizacionTransporteForm.get('lugarLlegada')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
        <small *ngIf="ticketAutorizacionTransporteForm.get('lugarLlegada')?.hasError('maxlength')"
          class="text-danger">*Máximo 50 caracteres</small>
      </div>

      <div class="col-lg-3 mb-2">
        <label for="pesoBrutoRecibido">Peso bruto - KG</label>
        <input (keypress)="keyDecimals($event)" class="form-control" formControlName="pesoBrutoRecibido"
          name="pesoBrutoRecibido" />
        <small *ngIf="ticketAutorizacionTransporteForm.get('pesoBrutoRecibido')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
        <small *ngIf="this.ticketAutorizacionTransporteForm.get('pesoBrutoRecibido')?.hasError('pattern')"
          class="letrasDanger">*Solo números y punto, hasta 3 decimales. Ej: 12.345</small>
      </div>

      <div class="col-lg-12 mb-2">
        <label for="observaciones">Observaciones (300 caracteres)</label>
        <textarea class="form-control" formControlName="observaciones" name="observaciones" rows="3"></textarea>
        <small *ngIf="ticketAutorizacionTransporteForm.get('observaciones')?.hasError('required')"
          class="text-danger">*Este campo es requerido</small>
        <small *ngIf="ticketAutorizacionTransporteForm.get('observaciones')?.hasError('maxlength')"
          class="text-danger">*Máximo 300 caracteres</small>
      </div>

      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )"
        *ngIf = "this.estadoSeleccionado == 1"
        [formularioValido]="ticketAutorizacionTransporteForm.invalid" [loading]="loading" [textBoton]="'Guardar'"
        class="row" aria-hidden="false">
      </app-lfsa-botones-formulario>
    </form>
  </div>
</ng-template>
<!-- END MODAL -->